import React from 'react';
import ReactGA from "react-ga4";

class Video extends React.Component{
    componentWillMount() {
        let ga_track_ids = '';
        ga_track_ids = this.props.GATrackingId;

        let GA_trackId = ga_track_ids ? ga_track_ids.split(',') : [];

        window.addEventListener('message', function (e) {
            try {
                var height = JSON.parse(e.data);

                if(height.action == 'portrait_video'){
                    if(document.querySelector('.video-object').style.maxWidth == ''){
                        document.querySelector('.video-object').style.maxWidth = '350px';
                        document.querySelector('.video-object').style.aspectRatio = '9/16';
                        document.querySelector('.video-object').style.height = 'auto';
                    }
                }else if(height.action == 'landscape_video')
                    document.querySelector('.video-object').style.cssText = '';

                if(height.body_height < 230)
                    return;

                var elem = document.getElementById('videoIframe');
                if (height.body_height) {
                    elem.style.height = height.body_height + 'px';
                    elem.parentElement.classList.remove("only-video");
                }

                if (height.action == 'vb_active') {
                    elem.parentElement.style.cssText = `height:${height.body_height + "px !important"}; padding-bottom:unset !important`;
                }

                if (height.action == 'video_ga_data' && GA_trackId.length != 0) {

                    const trackingObjects = GA_trackId.map(trackingId => ({ trackingId }));
                    ReactGA.initialize(trackingObjects);

                    let data = height.video_data;
                    if (data.message.action == "media-started") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "start",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })

                    } else if (data.message.action == "media-played") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "play",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    } else if (data.message.action == "media-paused") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "stop",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    } else if (data.message.action == "media-completed") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "end",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    }
                }
            }
            catch (e) {
                console.log(e)
            }
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.videoSrc !== this.props.videoSrc){
            var elem = document.getElementById('videoIframe');
            elem.parentElement.classList.add('only-video');
          
        }
    }
    render() {
        let props = this.props;
        let source;
        let portraitStyle = null;
        var referrer = props.videoSrc.substring(props.videoSrc.indexOf('referer=')+8 ,props.videoSrc.length);
       
        if (referrer) {
            if (
                referrer.includes("media.flickfusion") ||
                document.referrer.includes("media.flickfusion")
            ) {
                
                source = props.videoSrc.replace(
                    'referer=https://media.flickfusion.net',
                    "referer="
                );              
            
            } else if ((referrer) && (referrer != document.referrer)) {
                source = props.videoSrc + document.referrer;
            } else if (referrer == document.referrer) {
                source = props.videoSrc;
            }
        }else if(!referrer){
       source = props.videoSrc+document.referrer;
      
    }

        if (props.videoOrientation == 'P') {
        portraitStyle = {
            maxWidth:"350px",
            aspectRatio:"9/16",
                    height: "auto",
        }

        source = `${source}&portrait=true`;
    }
    
        return (
            <div className={"video-object only-video"} style={portraitStyle}>
                <iframe id={'videoIframe'} title="ff_video" frameBorder="0" src={source} scrolling="no"
                        allowFullScreen="yes" allow="autoplay; fullscreen accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe>
            </div>
        );
    }
}

export default Video;


// WEBPACK FOOTER //
// ./src/components/Video.js